import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import { availableInputFields, availableModulesToSync, syncFrequencyOptions } from '../../../../../../lib/appConstants';

const defaultType = 'procore';

class SystemIntegrations extends Component {
  state = {
    settings: {
      clientId: '',
      clientSecret: '',
      companyId: '',
      coiIdentifier: '',
      baseUrl: '',
      authUrl: '',
      projectId: '',
      // syncModules: [],
      enabled: false
    },
    lastSavedSettings: null,
    validationErrors: {},
    isSaved: false,
    isLoading: false
  };

  componentDidMount() {
    this.fetchIntegration();
  }

  fetchIntegration = () => {
    const { holderId, actions } = this.props;
    this.setState({ isLoading: true });
    actions.fetchIntegrations(holderId, (data) => {
      const defaultSettings = {
        clientId: '',
        clientSecret: '',
        companyId: '',
        coiIdentifier: '',
        baseUrl: '',
        authUrl: '',
        // syncModules: [],
      };

      if (data) {
        const dataLowerCase = Object.keys(data).reduce((acc, key) => {
          acc[key.toLowerCase()] = data[key];
          return acc;
        }, {});

        const mergedSettings = Object.keys(defaultSettings).reduce((acc, key) => {
          acc[key] = dataLowerCase[key.toLowerCase()] !== undefined ? dataLowerCase[key.toLowerCase()] : defaultSettings[key];
          return acc;
        }, {});

        const finalSettings = {
          ...mergedSettings,
          enabled: data.enabled === true
        };

        this.setState((prevState) => ({
          settings: {
            ...prevState.settings,
            ...finalSettings,
          },
          lastSavedSettings: finalSettings,
          isSaved: false,
          isLoading: false
        }));
      } else {
        const finalSettings = { ...defaultSettings, enabled: false };
        this.setState((prevState) => ({
          settings: {
            ...prevState.settings,
            ...finalSettings,
            enabled: prevState.settings.enabled
          },
          lastSavedSettings: finalSettings,
          isSaved: false,
          isLoading: false
        }));
      }
    }, (error) => {
      // console.log("error", error);
      this.setState({ isLoading: false });
    });
  };

  onFieldChange = (field, value) => {
    this.setState((prevState) => ({
      settings: { ...prevState.settings, [field] : field != 'coiIdentifier' ? value.trim() : value},
      isSaved: true,
      validationErrors: { ...prevState.validationErrors, [field]: '' }
    }));
  };

  onToggleEnable = () => {
    this.integrationStatusChange();
    this.setState((prevState) => ({
      settings: { ...prevState.settings, enabled: !prevState.settings.enabled },
      isSaved: true
    }));
  };

  // onSyncModuleChange = (module, checked) => {
  //   this.setState((prevState) => {
  //     const newSyncModules = checked
  //       ? [...prevState.settings.syncModules, module]
  //       : prevState.settings.syncModules.filter((m) => m !== module);

  //     return {
  //       settings: {
  //         ...prevState.settings,
  //         syncModules: newSyncModules
  //       },
  //       isSaved: false
  //     };
  //   });
  // };

  validateFields = () => {
    const errors = availableInputFields
      .filter(({ required }) => required)
      .reduce((acc, { field, label }) => {
        const value = this.state.settings[field];

        if (!value || value.trim() === '') {
          acc[field] = `Please Enter ${label}`;
          return acc;
        }

        return acc;
      }, {});

    const { coiIdentifier, projectId, syncModules } = this.state.settings;

    if (coiIdentifier && coiIdentifier.trim() !== '' && !/^[a-zA-Z0-9-_.]+(?: [a-zA-Z0-9-_.]+)*$/.test(coiIdentifier)) {
      errors.coiIdentifier = 'Allowed: a-z, A–Z, 0–9, single space, - , _ , .';
      this.setState((prevState) => ({
        settings: {
          ...prevState.settings,
          coiIdentifier: ''
        }
      }));
    }

    if (projectId && projectId.trim() !== '' && !/^\d+$/.test(projectId)) {
      errors.projectId = 'Project ID must be a Number.'
      this.setState((prevState) => ({
        settings: {
          ...prevState.settings,
          projectId: ''
        }
      }))
    }

    // if (!syncModules || syncModules.length === 0) {
    //   errors.syncModules = 'Please Select at Least One Module.';
    // }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  buildIntegrationPayload = () => {
    const { holderId } = this.props;
    const { settings } = this.state;

    return {
      type: defaultType,
      holderId,
      settings: {
        clientId: settings.clientId,
        clientSecret: settings.clientSecret,
        companyId: settings.companyId,
        coiIdentifier: settings.coiIdentifier,
        baseUrl: settings.baseUrl,
        authUrl: settings.authUrl,
        // syncModules: settings.syncModules
      },
      enabled: settings.enabled
    };
  };

  onConnectToProCore = () => {
    if (!this.validateFields()) return;

    const { actions } = this.props;
    const { settings } = this.state;

    const payload = this.buildIntegrationPayload();

    // console.log('Payload:', payload);
    this.setState({ isLoading: true });
    actions.createOrUpdateIntegration(payload, () => {
      // console.log('createIntegration successful');
      this.setState({
        lastSavedSettings: { ...settings },
        isSaved: true,
        isLoading: false
      });
      this.fetchIntegration();
    }, (error) => {
      // console.log('Error:', error);
      this.setState({ isLoading: false });
    });
  };

  integrationStatusChange = () => {
    const { holderId } = this.props;
    const { actions } = this.props;
    const { settings } = this.state;

    const payload = { holderId, enabled: settings.enabled == true ? 0 : 1 };

    this.setState({ isLoading: true });
    actions.updateIntegrationStatus(payload, () => {
      this.setState({
        lastSavedSettings: { ...settings },
        isSaved: true,
        isLoading: false
      });
    }, (error) => {
      this.setState({ isLoading: false });
    });
  };

  render() {
    const { settings, validationErrors, isSaved } = this.state;

    return (
      <div className="add-item-view add-entity-form-small">
        <section className="white-section holder-settings">
          <div className="integration-card add-item-form-subsection">
            <div className="add-item-header">
              <h3 className="label col-6">{`${defaultType} Integration`}</h3>
              <label className="checkbox">
                Enabled:
                <input
                  type="checkbox"
                  checked={settings.enabled}
                  onChange={this.onToggleEnable}
                  className="toggle-switch"
                />
              </label>
            </div>

            <div className="admin-form-field-wrapper">
              <div className="entity-info-form row">
                {availableInputFields.map(({ label, field, type, placeholder }) => (
                  <div key={field} className="col-6 entity-info-form-item">
                    <label>{label}</label>
                    {type === 'select' ? (
                      <select
                        value={settings[field]}
                        onChange={(e) => this.onFieldChange(field, e.target.value)}
                        disabled={!settings.enabled}
                        className={validationErrors[field] && settings[field] === '' ? 'placeholder-error' : ''}
                      >
                        <option value="" disabled hidden>
                          {validationErrors[field] ? `${validationErrors[field]}` : placeholder}
                        </option>
                        {syncFrequencyOptions.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        type={type}
                        placeholder={validationErrors[field] || placeholder}
                        value={(!validationErrors[field] && settings[field]) ? settings[field] : ''}
                        onChange={(e) => this.onFieldChange(field, e.target.value)}
                        disabled={!settings.enabled}
                        className={validationErrors[field] ? 'error' : ''}
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* <div className="entity-info-form row">
                <div className="syncModule-label-container col-12">
                  <label>Data Modules to Sync:</label>
                  {validationErrors.syncModules && (
                    <span className="error">{validationErrors.syncModules}</span>
                  )}
                </div>
                {availableModulesToSync.map((module) => (
                  <div key={module.label} className="col-6 checkbox-wrapper">
                    <input
                      type="checkbox"
                      checked={settings.syncModules.includes(module.value)}
                      onChange={(e) => this.onSyncModuleChange(module.value, e.target.checked)}
                      disabled={!settings.enabled}
                    />
                    <label>{module.label}</label>
                  </div>
                ))}
              </div> */}

              <div className="save-btn-wrapper row">
                <button
                  type="button"
                  className="btn save-btn"
                  onClick={this.onConnectToProCore}
                  disabled={!settings.enabled || !isSaved}
                >
                  Connect to ProCore
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(null, mapDispatchToProps)(SystemIntegrations);